import { useRef, useState } from 'react';
export default function useMapSizeController(step) {
    const svgElementRef = useRef(null);
    const [mapSize, setMapSize] = useState({
        initialSize: 0,
        size: 0,
        isControlled: false,
    });
    function increaseSize() {
        setMapSize((prev) => {
            if (!svgElementRef.current) {
                return prev;
            }
            const width = svgElementRef.current.getBoundingClientRect().width;
            return {
                initialSize: prev.initialSize === 0 ? width : prev.initialSize,
                size: width + step,
                isControlled: true,
            };
        });
    }
    function decreaseSize() {
        setMapSize((prev) => {
            if (!svgElementRef.current) {
                return prev;
            }
            const width = svgElementRef.current.getBoundingClientRect().width;
            return {
                initialSize: prev.initialSize === 0 ? width : prev.initialSize,
                size: Math.max(width - step, 100),
                isControlled: true,
            };
        });
    }
    function resetSize() {
        setMapSize((prev) => {
            return {
                initialSize: 0,
                size: prev.initialSize,
                isControlled: false,
            };
        });
    }
    return {
        svgElementRef,
        size: mapSize.size,
        isControlled: mapSize.isControlled,
        increaseSize,
        decreaseSize,
        resetSize,
    };
}
